const fpToday = new Date();
const fpThreeMonthsLater = new Date(fpToday);
fpThreeMonthsLater.setMonth(fpToday.getMonth() + 3);

flatpickr("#din-ndis-v2-end-date-flatpickr", {
dateFormat: "Y-m-d",
altFormat: "d/m/Y",
altInput: true,
defaultDate: fpThreeMonthsLater,
disableMobile: true,
minDate: fpToday,
allowInput: true
});

const deliScheduleDivNdis = document.querySelector(".delivery-schedule__wrapper");
const openDeliveryCheckForNDIS = document.getElementById(`open-deli-schedule-div-for-ndis`);
openDeliveryCheckForNDIS.addEventListener("click", function (e) {
    e.preventDefault();
    if (deliScheduleDivNdis) {
        deliScheduleDivNdis.classList.add("active");
    }
});

function dinNdisSetDisplay(selector, displayValue) {
document.querySelectorAll(selector).forEach(el => {
    el.style.display = displayValue;
});
}
const dinHideNdisForm = function (ndisType) {
document.getElementById('ndis-quote-form-anchor').scrollIntoView({ behavior: 'smooth' });
dinNdisSetDisplay('.din-custom-v2-ndis-wrapper', 'none');
if (ndisType === "self-managed") {
    document.getElementById(`din-ndis-v2-wait-copy`).textContent = "Creating your Dineamic self-managed NDIS account now. Please wait...";
} else {
    document.getElementById(`din-ndis-v2-wait-copy`).textContent = "Submitting the form now. Please wait...";
}
dinNdisSetDisplay('.din-custom-v2-ndis-wrapper-wait', 'flex');
};
const dinShowNdisResults = function (type = "self-managed", email = "your email address submitted", scEmail = "not-provided@dineamic.com.au") {
dinNdisSetDisplay('.din-custom-v2-ndis-wrapper-wait', 'none');
dinNdisSetDisplay('.din-custom-v2-ndis-wrapper-result', 'flex');
const pmAmcontainer = document.querySelector('.din-custom-v2-pm-am-ndis-container-result');
if (type === "self-managed") {
    dinNdisSetDisplay('.din-custom-v2-sm-ndis-container-result', 'flex');
    const emailTarget = document.getElementById('dinV2SmNdisEmailSubmitted');
    if (emailTarget) emailTarget.textContent = email;
} else if (type === "bot") {
    dinNdisSetDisplay('.din-custom-v2-sm-ndis-container-result', 'flex');
} else if (type === "plan-managed") {
    const pmWithQuoteHtml = `
    <div class="fs-body-100" style="font-weight: bold;">Thanks for reaching out. We've sent an email to ${email}${scEmail && scEmail !== 'not-provided@dineamic.com.au' ? ` and ${scEmail}` : ''}.</div>
    <div class="fs-body-100">This includes your NDIS quote and service agreement.</div>
    <div class="fs-body-100">Feel free to get in touch with us if you have any questions.</div>
    `;
    pmAmcontainer.insertAdjacentHTML('beforeend', pmWithQuoteHtml);
    dinNdisSetDisplay('.din-custom-v2-pm-am-ndis-container-result', 'flex');
} else {
    const amHtml = `
    <div class="fs-body-100" style="font-weight: bold;">Thanks for reaching out. We've sent an email to ${email}${scEmail && scEmail !== 'not-provided@dineamic.com.au' ? ` and ${scEmail}` : ''}.</div>
    <div class="fs-body-100">This includes your NDIS quote and service agreement.</div>
    <div class="fs-body-100">Feel free to get in touch with us if you have any questions.</div>
    `;
    pmAmcontainer.insertAdjacentHTML('beforeend', amHtml);
    dinNdisSetDisplay('.din-custom-v2-pm-am-ndis-container-result', 'flex');
}
};

let ndisV2SelectedType = "";
let ndisV2OrderingFrequency = "";
let ndisV2PlanContact = "";
let ndisV2QuoteRequired;
const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const phonePattern = /^(?:\+?61|0)[2-478](?:[ -]?[0-9]){8}$/; // const phonePattern = /^(?:\+614|04)\d{8}$/;
const ndisNumberPattern = /^[45]\d{8}$/;

document.getElementById('din-cv2nf').addEventListener('submit', function(e) {
e.preventDefault();
const submitBtnDinNdisV2 = document.querySelector(`.din-ndis-v2-ndis-submit`);
if (!submitBtnDinNdisV2.classList.contains('not-ready')) {
    let dinNdisHasError = false;
    const dinNdisGetVal = id => document.getElementById(id)?.value?.trim() || "";
    const ndisFormData = {
    type: ndisV2SelectedType,
    firstName: dinNdisGetVal('din-ndis-v2-first-name'),
    lastName: dinNdisGetVal('din-ndis-v2-last-name'),
    email: dinNdisGetVal('din-ndis-v2-email-address'),
    phone: dinNdisGetVal('din-ndis-v2-phone'),
    ndisNumber: dinNdisGetVal('din-ndis-v2-ndis-number'),
    planEndDate: dinNdisGetVal('din-ndis-v2-end-date-flatpickr'),
    quote: ndisV2SelectedType === "plan-managed" ? true : ndisV2QuoteRequired,
    readyMeals: dinNdisGetVal('din-ndis-v2-ready-meals'),
    mealsForTwo: dinNdisGetVal('din-ndis-v2-meals-for-two'),
    soups: dinNdisGetVal('din-ndis-v2-soups'),
    frequency: ndisV2OrderingFrequency,
    planContact: ndisV2PlanContact,
    planEmail: dinNdisGetVal('din-ndis-v2-email-address-plan'),
    agencyEmail: dinNdisGetVal('din-ndis-v2-email-address-agency'),
    website: dinNdisGetVal('din-ndis-v2-website'),
    };
    const dinNdisGetInput = id => document.getElementById(id) || "";
    const ndisFormDataInputField = {
    type: dinNdisGetInput('din-ndis-v2-ndis-type'),
    firstName: dinNdisGetInput('din-ndis-v2-first-name'),
    lastName: dinNdisGetInput('din-ndis-v2-last-name'),
    email: dinNdisGetInput('din-ndis-v2-email-address'),
    phone: dinNdisGetInput('din-ndis-v2-phone'),
    ndisNumber: dinNdisGetInput('din-ndis-v2-ndis-number'),
    planEndDate: dinNdisGetInput('din-ndis-v2-end-date-flatpickr'),
    readyMeals: dinNdisGetInput('din-ndis-v2-ready-meals'),
    mealsForTwo: dinNdisGetInput('din-ndis-v2-meals-for-two'),
    soups: dinNdisGetInput('din-ndis-v2-soups'),
    frequency: dinNdisGetInput('din-ndis-v2-frequency'),
    planContact: dinNdisGetInput('din-ndis-v2-contact-type'),
    planEmail: dinNdisGetInput('din-ndis-v2-email-address-plan'),
    agencyEmail: dinNdisGetInput('din-ndis-v2-email-address-agency'),
    website: dinNdisGetInput('din-ndis-v2-website'),
    };
    const showDinNdisErrorHeading = function () {
    document.querySelectorAll('.din-ndis-v2-error-wrapper').forEach(wrapper => {
        wrapper.style.display = 'flex';
    });
    const dinNdisErrorHeading = document.getElementById("din-ndis-v2-error-heading");
    if (!dinNdisErrorHeading.textContent) {
        dinNdisErrorHeading.textContent = "Please provide the following information and try again.";
    }
    }
    const dinShowNdisError = function (field) {
    const fieldLabels = {
        firstName: "First Name",
        lastName: "Last Name",
        email: "Email Address",
        phone: "Phone Number",
        ndisNumber: "NDIS Number",
        planEndDate: "NDIS Plan End Date",
        readyMeals: "Number of Ready Meals",
        mealsForTwo: "Number of Meals for Two",
        soups: "Number of Soups",
        frequency: "Order Frequency",
        planContact: "Your Agency Contact",
        planEmail: "Email Address",
        agencyEmail: "Email Address",
    };       
    const isEmailField = ["email", "planEmail", "agencyEmail"].includes(field);
    const isPhoneField = ["phone"].includes(field);
    const isNdisNumberField = ["ndisNumber"].includes(field);
    const fieldValue = ndisFormData[field];
    const inputElement = ndisFormDataInputField[field];
    let isValid = true;
    let isFieldEmpty;
    if (isEmailField) {
        isValid = emailPattern.test(fieldValue);
        isFieldEmpty = !fieldValue?.trim();
    } else if (isPhoneField) {
        isValid = phonePattern.test(fieldValue);
        isFieldEmpty = !fieldValue?.trim();
    } else if (field === "quote") {
        if (fieldValue === true || fieldValue === false) {
        isValid = true;
        } else {
        isValid = false;
        }
    } else if (isNdisNumberField) {
        isValid = ndisNumberPattern.test(fieldValue);
        isFieldEmpty = !fieldValue?.trim();
    } else {
        isValid = Boolean(fieldValue);
    }
    if (!isValid) {
        dinNdisHasError = true;
        showDinNdisErrorHeading();
        inputElement.style.border = "0.8px solid red";
        if ((isEmailField || isPhoneField) && !isFieldEmpty) {
        dinNdisErrorList.insertAdjacentHTML('beforeend', `<li>${fieldLabels[field]} is not formatted properly.</li>`);
        } else if (isNdisNumberField && !isFieldEmpty) {
        dinNdisErrorList.insertAdjacentHTML('beforeend', `<li>Your NDIS number must be 9 digits long and start with 4 or 5.</li>`);
        } else {
        dinNdisErrorList.insertAdjacentHTML('beforeend', `<li>${fieldLabels[field]}</li>`);
        }
    }
    };
    const checkEachDinNdisField = function (arr, isRequired) {
    for (const field of arr) {
        if (isRequired) {
        dinShowNdisError(field);
        } else if (ndisFormData[field]?.trim()) {
        dinShowNdisError(field);
        }
    }
    }
    const dinNdisErrorList = document.getElementById("din-ndis-v2-error-list");
    if (dinNdisErrorList) {
    dinNdisErrorList.innerHTML = '';
    }
    Object.values(ndisFormDataInputField).forEach(input => {
    if (input && input.style.border === '0.8px solid red') {
        input.style.border = ''
    }
    });
    // console.log("Form submission data: ", ndisFormData);
    if (!ndisFormData.website) {
        const dinNdisV2Today = new Date();
        const dinNdisV2EndDateFormatted = new Date (ndisFormData.planEndDate);
        const dinNdisV2TimeDiff = dinNdisV2EndDateFormatted.getTime() - dinNdisV2Today.getTime();
        const dinNdisV2DaysDiff = dinNdisV2TimeDiff / (1000 * 60 * 60 * 24);
        const dinNdisV2WeeksDiff = dinNdisV2DaysDiff / 7;
        const dinNdisV2WeeksRemaining = Math.floor(dinNdisV2WeeksDiff);
        let dinNdisV2NumOfOrders;
        dinNdisV2NumOfOrders = Math.floor(dinNdisV2TimeDiff / 1000);
        let dinNdisV2FrequencyInSeconds = 0;
        if (ndisFormData.frequency === "every-week") {
        dinNdisV2FrequencyInSeconds = 604800;
        } else if (ndisFormData.frequency === "every-2-weeks") {
        dinNdisV2FrequencyInSeconds = 1209600;
        } else {
        dinNdisV2FrequencyInSeconds = 2419200;
        }
        dinNdisV2NumOfOrders = Math.floor(dinNdisV2NumOfOrders / dinNdisV2FrequencyInSeconds);
        const melbTime = new Date().toLocaleTimeString("en-AU", {
        timeZone: "Australia/Melbourne",
        hour: "2-digit",
        minute: "2-digit",
        hour12: false
        });
        if (ndisFormData.type === "plan-managed") {
        const dinPmNdisOptionalFields = [`phone`];
        checkEachDinNdisField(dinPmNdisOptionalFields, false);
        const dinPmNdisRequiredFields = [`email`, `firstName`, `lastName`, `ndisNumber`, `planEndDate`, `quote`, `readyMeals`, `mealsForTwo`, `soups`, `frequency`, `planContact`, `planEmail`];
        checkEachDinNdisField(dinPmNdisRequiredFields, true);
        if (!dinNdisHasError) {
            dinHideNdisForm("plan-managed");
            grecaptcha.ready(function () {
            grecaptcha.execute("6LcdMH8rAAAAADgT5wqXYGrVT2zB19e7b1AA341F", { action: "submit_form" }).then(function (token) {
                const flowParamsEmbeddedVarPlanManaged = JSON.stringify({
                firstName: `${ndisFormData.firstName}`,
                lastName: `${ndisFormData.lastName}`,
                email: `${ndisFormData.email}`,
                phone: `${ndisFormData.phone}`,
                ndisNumber: ndisFormData.ndisNumber,
                planEndDate: `${ndisFormData.planEndDate}`,
                quote: ndisFormData.quote,
                readyMeals: ndisFormData.readyMeals,
                mealsForTwo: ndisFormData.mealsForTwo,
                soups: ndisFormData.soups,
                frequency: `${ndisFormData.frequency}`,
                planContact: `${ndisFormData.planContact}`,
                planEmail: `${ndisFormData.planEmail}`,
                recaptchaToken: `${token}`,
                remainingWeeks: dinNdisV2WeeksRemaining,
                numOfOrders: dinNdisV2NumOfOrders,
                melbTime: `${melbTime}`,
                });
                const queryParamsPlanManaged = new URLSearchParams({
                requestId: "8a06b100-6cff-11f0-9cba-45fd36ae4ef9",
                flowParamsEmbedded: flowParamsEmbeddedVarPlanManaged,
                });
                fetch('/apps/apiease/integration/caller/call?' + queryParamsPlanManaged).
                then(function(response) {return response.json();}).
                then(function(jsonResponsePlanManaged) {
                    // console.log(jsonResponsePlanManaged);
                    if (jsonResponsePlanManaged.data.googleRecaptureStatus === "success") {
                    // console.log(ndisFormData);
                    if (ndisFormData.planContact === "Support Coordinator") {
                        dinShowNdisResults("agency-managed", jsonResponsePlanManaged.data.requestFlowParameters.email, jsonResponsePlanManaged.data.requestFlowParameters.planEmail);
                    } else {
                        dinShowNdisResults("plan-managed", jsonResponsePlanManaged.data.requestFlowParameters.email);
                    }
                    } else if (jsonResponsePlanManaged.data.googleRecaptureStatus === "failure") {
                    dinShowNdisResults("bot", jsonResponseSelfManaged.data.requestFlowParameters.email);
                    }
                });
            });
            });
        }
        } else if (ndisFormData.type === "self-managed") {
        const dinSmNdisRequiredFields = [`email`, `firstName`, `lastName`, `ndisNumber`];
        checkEachDinNdisField(dinSmNdisRequiredFields, true);
        if (!dinNdisHasError) {
            dinHideNdisForm("self-managed");
            grecaptcha.ready(function () {
            grecaptcha.execute("6LcdMH8rAAAAADgT5wqXYGrVT2zB19e7b1AA341F", { action: "submit_form" }).then(function (token) {
                const flowParamsEmbeddedVarSelfManaged = JSON.stringify({
                firstName: `${ndisFormData.firstName}`,
                lastName: `${ndisFormData.lastName}`,
                email: `${ndisFormData.email}`,
                ndisNumber: ndisFormData.ndisNumber,
                recaptchaToken: `${token}`,
                melbTime: `${melbTime}`,
                });
                const queryParamsSelfManaged = new URLSearchParams({
                requestId: "3c323430-6062-11f0-834a-7d549f4d34de",
                flowParamsEmbedded: flowParamsEmbeddedVarSelfManaged,
                });
                fetch('/apps/apiease/integration/caller/call?' + queryParamsSelfManaged).
                then(function(response) {return response.json();}).
                then(function(jsonResponseSelfManaged) {
                    // console.log(jsonResponseSelfManaged);
                    if (jsonResponseSelfManaged.data.googleRecaptureStatus === "success") {
                    dinShowNdisResults("self-managed", jsonResponseSelfManaged.data.requestFlowParameters.email);
                    } else if (jsonResponseSelfManaged.data.googleRecaptureStatus === "failure") {
                    dinShowNdisResults("bot", jsonResponseSelfManaged.data.requestFlowParameters.email);
                    }
                });
            });
            });
        }
        } else if (ndisFormData.type === "agency-managed") {
        const dinAmNdisOptionalFields = [`phone`, `agencyEmail`];
        checkEachDinNdisField(dinAmNdisOptionalFields, false);
        const dinAmNdisRequiredFields = [`email`, `firstName`, `lastName`, `ndisNumber`, `planEndDate`, `readyMeals`, `mealsForTwo`, `soups`, `frequency`];
        checkEachDinNdisField(dinAmNdisRequiredFields, true);
            if (!dinNdisHasError) {
            dinHideNdisForm("agency-managed");
            if (!ndisFormData.agencyEmail) {
                ndisFormData.agencyEmail = "not-provided@dineamic.com.au";
            }
            grecaptcha.ready(function () {
                grecaptcha.execute("6LcdMH8rAAAAADgT5wqXYGrVT2zB19e7b1AA341F", { action: "submit_form" }).then(function (token) {
                const flowParamsEmbeddedVarAgencyManaged = JSON.stringify({
                    firstName: `${ndisFormData.firstName}`,
                    lastName: `${ndisFormData.lastName}`,
                    email: `${ndisFormData.email}`,
                    phone: `${ndisFormData.phone}`,
                    ndisNumber: ndisFormData.ndisNumber,
                    planEndDate: `${ndisFormData.planEndDate}`,
                    quote: ndisFormData.quote,
                    readyMeals: ndisFormData.readyMeals,
                    mealsForTwo: ndisFormData.mealsForTwo,
                    soups: ndisFormData.soups,
                    frequency: `${ndisFormData.frequency}`,
                    agencyEmail: `${ndisFormData.agencyEmail}`,
                    recaptchaToken: `${token}`,
                    remainingWeeks: dinNdisV2WeeksRemaining,
                    numOfOrders: dinNdisV2NumOfOrders,
                    melbTime: `${melbTime}`,
                });
                const queryParamsAgencyManaged = new URLSearchParams({
                    requestId: "cb258940-6e71-11f0-a55f-438e8787427e",
                    flowParamsEmbedded: flowParamsEmbeddedVarAgencyManaged,
                });
                fetch('/apps/apiease/integration/caller/call?' + queryParamsAgencyManaged).
                    then(function(response) {return response.json();}).
                    then(function(jsonResponseAgencyManaged) {
                    // console.log(jsonResponseAgencyManaged);
                    if (jsonResponseAgencyManaged.data.googleRecaptureStatus === "success") {
                        dinShowNdisResults("agency-managed", jsonResponseAgencyManaged.data.requestFlowParameters.email, ndisFormData.agencyEmail);
                    } else if (jsonResponseAgencyManaged.data.googleRecaptureStatus === "failure") {
                        dinShowNdisResults("bot", jsonResponseSelfManaged.data.requestFlowParameters.email);
                    }
                    });
                });
            });
            }
        }
    }
}
});
document.querySelectorAll('.din-custom-v2-ndis-option').forEach(option => {
option.addEventListener('click', (event) => {
    event.preventDefault();
    if (option.dataset.option === "self-managed") {
    document.getElementById('din-custom-v2-sm-pathway-p').style.display = "block";
    document.getElementById('din-custom-v2-pm-am-pathway-p').style.display = "none";
    } else {
    document.getElementById('din-custom-v2-sm-pathway-p').style.display = "none";
    document.getElementById('din-custom-v2-pm-am-pathway-p').style.display = "block";
    }
    // Add .selected to clicked option and remove from others
    document.querySelectorAll('.din-custom-v2-ndis-option').forEach(o => o.classList.remove('selected'));
    option.classList.add('selected');
    // Get selected data-option (e.g., plan-managed, agency-managed, self-managed)
    const selectedOption = option.getAttribute('data-option'); // e.g., "plan-managed"
    // Update ndisV2SelectedType
    ndisV2SelectedType = selectedOption;
    // Remove not-ready class from the button
    document.querySelectorAll('.din-ndis-v2-ndis-submit').forEach(o => o.classList.remove('not-ready'));
    // Show/hide fields based on din-ndis-show attribute
    document.querySelectorAll('.din-ndis-show-hide').forEach(el => {
    const showFor = el.getAttribute('din-ndis-show') || ''; // e.g., "plan,agency"
    const showList = showFor.split(',').map(s => s.trim());

    if (showList.includes(selectedOption)) {
        el.classList.remove('hidden');
    } else {
        el.classList.add('hidden');
    }
    });
});
});

document.querySelectorAll('.din-custom-v2-ndis-frequency-option').forEach(option => {
option.addEventListener('click', (event) => {
    event.preventDefault();
    document.querySelectorAll('.din-custom-v2-ndis-frequency-option').forEach(o => o.classList.remove('selected'));
    option.classList.add('selected');
    const selectedFrequency = option.getAttribute('data-option');
    ndisV2OrderingFrequency = selectedFrequency;
    const frequencyOptionWrapper = document.getElementById(`din-ndis-v2-frequency`);
    if (frequencyOptionWrapper.style.border === "0.8px solid red") {
    frequencyOptionWrapper.style.border = ""
    }
});
});

document.querySelectorAll('.din-custom-v2-ndis-contact-option').forEach(option => {
option.addEventListener('click', (event) => {
    event.preventDefault();
    document.querySelectorAll('.din-custom-v2-ndis-contact-option').forEach(o => o.classList.remove('selected'));
    option.classList.add('selected');
    const selectedContact = option.getAttribute('data-option');
    if (selectedContact === "support-coordinator") {
    ndisV2PlanContact = "Support Coordinator"
    } else {
    ndisV2PlanContact = "Plan Manager"
    }
    const contactOptionWrapper = document.getElementById(`din-ndis-v2-contact-type`);
    if (contactOptionWrapper.style.border === "0.8px solid red") {
    contactOptionWrapper.style.border = ""
    }
});
});

function updateDinV2Qty(id, value) {
switch (id) {
    case 'din-ndis-v2-ready-meals':
    ndisV2NumOfReadyMeals = value;
    break;
    case 'din-ndis-v2-meals-for-two':
    ndisV2NumOfMealsForTwo = value;
    break;
    case 'din-ndis-v2-soups':
    ndisV2NumberOfSoups = value;
    break;
}
}
document.querySelectorAll('.din-v2-qty-minus').forEach(btn => {
btn.addEventListener('click', (event) => {
    event.preventDefault();
    const targetId = btn.getAttribute('data-target');
    const input = document.getElementById(targetId);
    let value = parseInt(input.value) || 0;
    if (value > 0) input.value = value - 1;
    updateDinV2Qty(input.id, input.value);
});
});
document.querySelectorAll('.din-v2-qty-plus').forEach(btn => {
btn.addEventListener('click', (event) => {
    event.preventDefault();
    const targetId = btn.getAttribute('data-target');
    const input = document.getElementById(targetId);
    let value = parseInt(input.value) || 0;
    input.value = value + 1;
    updateDinV2Qty(input.id, input.value);
});
});
document.querySelectorAll('.din-v2-qty-selector input').forEach(input => {
input.addEventListener('input', (event) => {
    event.preventDefault();
    let value = parseFloat(input.value);
    if (isNaN(value) || value < 0) {
    input.value = 0;
    } else {
    input.value = Math.floor(value); // force integer
    }
    updateDinV2Qty(input.id, input.value);
});
});

document.querySelectorAll(`.din-ndis-v2-input-value`).forEach(input => {
input.addEventListener('input', (event) => {
    event.preventDefault();
    const inputType = input.getAttribute('type');
    const value = input.value.trim();
    if (inputType === 'email') {
    if (emailPattern.test(value)) {
        input.style.border = "";
    } else {
        input.style.border = "0.8px solid red";
    }
    } else if (inputType === 'tel') {
    if (phonePattern.test(value)) {
        input.style.border = "";
    } else {
        input.style.border = "0.8px solid red";
    }
    } else if (input.id === 'din-ndis-v2-ndis-number') {
    if (ndisNumberPattern.test(value)) {
        input.style.border = "";
    } else {
        input.style.border = "0.8px solid red";
    }
    } else {
    if (input.style.border === "0.8px solid red") {
        input.style.border = "";
    }
    }
});
});
document.querySelectorAll('.quantity-btn').forEach(button => {
    button.addEventListener('click', function() {
        const action = this.getAttribute('data-action');
        const targetInput = document.getElementById(this.getAttribute('data-target'));
        let currentValue = parseInt(targetInput.value, 10) || 0;

        if (action === 'increase') {
            targetInput.value = currentValue + 1;
        } else if (action === 'decrease' && currentValue > 0) {
            targetInput.value = currentValue - 1;
        }
    });
});
const today = new Date();
const nextYear = new Date(today.setFullYear(today.getFullYear() + 1));
const formattedDate = nextYear.toISOString().split('T')[0]; // Format as YYYY-MM-DD
document.getElementById('dinNdisEndDate').value = formattedDate;
let dinNdisPlanEndDate, dinNumberOfReadyMeals, dinNumberOfMealsForTwo, dinNumberOfSoups, dinOrderingFrequency;
let dinNdisNumOfOrders, dinNdisCopayment, dinNdisContribution, dinNdisCopaymentTotal, dinNdisContributionTotal;
function formatCurrency(amount) {
    return new Intl.NumberFormat('en-AU', {
        style: 'currency',
        currency: 'AUD',
    }).format(amount);
}
document.getElementById('dinNdisEstimateCalc').addEventListener('submit', function(event) {
    event.preventDefault();
    dinNdisPlanEndDate = document.getElementById('dinNdisEndDate').value;
    dinNumberOfReadyMeals = parseInt(document.getElementById('dinReadyMeals').value, 10);
    dinNumberOfMealsForTwo = parseInt(document.getElementById('dinMealsForTwo').value, 10);
    dinNumberOfSoups = parseInt(document.getElementById('dinSoups').value, 10);
    dinOrderingFrequency = document.getElementById('dinOrderingFrequency').value;
    const today = new Date();
    const endDate = new Date(dinNdisPlanEndDate);
    const timeDifference = endDate.getTime() - today.getTime();
    dinNdisNumOfOrders = Math.floor(timeDifference / 1000);
    let frequencyInSeconds = 0;
    if (dinOrderingFrequency === 'every_week') {
        frequencyInSeconds = 604800;
    } else if (dinOrderingFrequency === 'every_2_weeks') {
        frequencyInSeconds = 1209600;
    } else if (dinOrderingFrequency === 'every_4_weeks') {
        frequencyInSeconds = 2419200;
    }
    dinNdisNumOfOrders = Math.floor(dinNdisNumOfOrders / frequencyInSeconds);
    const x = dinNumberOfReadyMeals;
    const y = dinNumberOfMealsForTwo;
    const z = dinNumberOfSoups;
    dinNdisCopayment = ((x * 11.5) + (y * 16.95) + (z * 8)) * 0.25; // 25% of the total cost
    dinNdisContribution = ((x * 11.5) + (y * 16.95) + (z * 8)) * 0.75 + 15; // 75% of the total cost + $15
    dinNdisCopaymentTotal = dinNdisCopayment * dinNdisNumOfOrders;
    dinNdisContributionTotal = dinNdisContribution * dinNdisNumOfOrders;
    /* console.log({
        dinNdisNumOfOrders: dinNdisNumOfOrders,
        dinNdisCopayment: dinNdisCopayment,
        dinNdisContribution: dinNdisContribution,
        dinNdisCopaymentTotal: dinNdisCopaymentTotal,
        dinNdisContributionTotal: dinNdisContributionTotal
    });
    */
    document.getElementById('dinNdisCopaymentResult').textContent = formatCurrency(dinNdisCopayment);
    document.getElementById('dinNdisContributionResult').textContent = formatCurrency(dinNdisContribution);
    document.getElementById('dinNdisNumOfOrdersResult').textContent = dinNdisNumOfOrders;
    document.getElementById('dinNdisCopaymentTotalResult').textContent = formatCurrency(dinNdisCopaymentTotal);
    document.getElementById('dinNdisContributionTotalResult').textContent = formatCurrency(dinNdisContributionTotal);
    document.getElementById('dinNdisResults').style.display = 'block';
    /* console.log({
        dinNdisNumOfOrders: dinNdisNumOfOrders,
        dinNdisCopayment: dinNdisCopayment,
        dinNdisContribution: dinNdisContribution,
        dinNdisCopaymentTotal: dinNdisCopaymentTotal,
        dinNdisContributionTotal: dinNdisContributionTotal
    });
    */
    const formattedForFormEndDate = endDate.toLocaleDateString("en-GB");
    document.getElementById('din-ndis-v2-ready-meals').value = x;
    document.getElementById('din-ndis-v2-meals-for-two').value = y;
    document.getElementById('din-ndis-v2-soups').value = z;
    document.querySelectorAll('.din-custom-v2-ndis-frequency-option').forEach(option => {
        option.classList.remove('selected');
        const selectedFrequency = option.getAttribute('data-option');
        if (dinOrderingFrequency === 'every_week' && selectedFrequency === 'every-week') {
        ndisV2OrderingFrequency = selectedFrequency;
        option.classList.add('selected');
        } else if (dinOrderingFrequency === 'every_2_weeks' && selectedFrequency === 'every-2-weeks') {
        ndisV2OrderingFrequency = selectedFrequency;
        option.classList.add('selected');
        } else if (dinOrderingFrequency === 'every_4_weeks' && selectedFrequency === 'every-4-weeks') {
        ndisV2OrderingFrequency = selectedFrequency;
        option.classList.add('selected');
        }
    });
});

const dinNdisV2PmHIWBtn = document.getElementById("dinNidsHiwButton-PlanManaged");
const dinNdisV2SmHIWBtn = document.getElementById("dinNidsHiwButton-SelfManaged");
const dinNdisV2AmHIWBtn = document.getElementById("dinNidsHiwButton-AgencyManaged");
const switchDinNdisTypeOptionInForm = function (type) {
    document.querySelectorAll('.din-custom-v2-ndis-option').forEach(o => o.classList.remove('selected'));
    const optionElement = document.querySelector(`.din-custom-v2-ndis-option[data-option="${type}"]`);
    if (optionElement) {
    optionElement.classList.add("selected");
    }
    ndisV2SelectedType = type;
    if (type === "plan-managed") {
    document.getElementById('din-custom-v2-sm-pathway-p').style.display = "none";
    document.getElementById('din-custom-v2-pm-am-pathway-p').style.display = "block";
    } else if (type === "self-managed") {
    document.getElementById('din-custom-v2-sm-pathway-p').style.display = "block";
    document.getElementById('din-custom-v2-pm-am-pathway-p').style.display = "none";
    } else if (type === "agency-managed") {
    document.getElementById('din-custom-v2-sm-pathway-p').style.display = "none";
    document.getElementById('din-custom-v2-pm-am-pathway-p').style.display = "block";
    }
    document.querySelectorAll('.din-ndis-v2-ndis-submit').forEach(o => o.classList.remove('not-ready'));
    document.querySelectorAll('.din-ndis-show-hide').forEach(el => {
    const showFor = el.getAttribute('din-ndis-show') || ''; // e.g., "plan,agency"
    const showList = showFor.split(',').map(s => s.trim());
    if (showList.includes(type)) {
        el.classList.remove('hidden');
    } else {
        el.classList.add('hidden');
    }
    });
};
if (dinNdisV2PmHIWBtn) {
    dinNdisV2PmHIWBtn.addEventListener("click", function (event) {
    event.preventDefault();
    switchDinNdisTypeOptionInForm("plan-managed");
    });
}
if (dinNdisV2SmHIWBtn) {
    dinNdisV2SmHIWBtn.addEventListener("click", function (event) {
    event.preventDefault();
    switchDinNdisTypeOptionInForm("self-managed");
    });
}
if (dinNdisV2AmHIWBtn) {
    dinNdisV2AmHIWBtn.addEventListener("click", function (event) {
    event.preventDefault();
    switchDinNdisTypeOptionInForm("agency-managed");
    });
}